import React from "react";
import {Box, Typography, Alert} from "@mui/material";
import {withAuthenticationRequired} from "@auth0/auth0-react";
import Loading from "../components/common/Loading";
import {useTranslation} from "react-i18next";

function Unauthorized({updateCurrentStep}) {
    const {t} = useTranslation();

    return (
        <>
            <Box sx={{width: "100%", paddingLeft: "100px"}} textAlign="center" verticalAlign="middle">
                <Alert sx={{marginTop: 2}} severity="warning">
                    <Typography>{t('unauthorizedBeheer')}</Typography>
                </Alert>
            </Box>
        </>
    );
}

export default withAuthenticationRequired(Unauthorized, {
    onRedirecting: () => <Loading/>,
    returnTo: '/nieuwe-reservatie'
});
